module.exports = __webpack_public_path__ + "img/sad.9c655678.png";